<template>
	<div class="shapeTag">
		<!--弹出框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" :close="handleClose">
			<div class="title">
				<span class="checktip">* </span>形状名称： <input type="text" class="input mid" v-model="dialogData.name">
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()">确 定</el-button>
		  </span>
		</el-dialog>
		<navZcy v-bind:num="'3-5'" style="min-width: 1110px;"></navZcy>
		<div class="line"></div>
		<div class="main">
			<div class="top cf">
				<div class="topL fl"><span>零件形状</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="line"></div>
			<div class="dataTag">
				<!--操作按钮-->
				<div class="handle">
					<div class="fl">
						<img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
						<span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
					</div>
					<div class="handleBtn fr">
						<el-button type="primary" size="small" @click="handleAdd">添加</el-button>
						<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
					</div>
				</div>
				<!--列表内容-->
				<div class="tableData" style="text-align: center;">
					<el-table 
						ref="multipleTable"
						:data="tableData" 
						border 
						@selection-change="handleSelectionChange" 
						style="width: 100%;border-bottom: 1px solid #ddd;">
						<el-table-column type="selection" width="200px">
						</el-table-column>
						<el-table-column type="index" label="序号" width="250px">
						</el-table-column>
						<el-table-column prop="name" label="零件形状" width="250px">
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
								<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!--分页-->
				<div class="page">
					<el-pagination 
						background 
						:current-page="tableDataArr.currentPage" 
						:page-sizes="[10,20,30,40]" 
						:page-size="tableDataArr.pageSize" 
						layout="total, sizes, prev, pager, next, jumper" 
						:total="tableDataArr.totalSize"
				     	@current-change="handleCurrentChange" 
				     	@size-change="handleSizeChange">						
					</el-pagination>
				</div>
			</div>
		</div>
	</div>	
</template>

<script>
import '../assets/css/style.css'
import navZcy from './nav'
export default {
	data() {
		return {
			dialogTitle: "",      //弹出框标题
			dialogVisible: false, //弹出框是否显示
			tableDataArr: {		  //分页参数
				currentPage: 1,
				pageSize: 10,
				totalSize: 0
			},
			tableData: [],		 //列表内容参数
			dialogData: {},      //弹出框参数
			multipleSelection: []
		}
	},
	methods: {
		//页面刷新
		refresh() {
			location.reload();
		},
		//获取用户类型
		getStyleTag() {
			let url = "/lightApi/product/shape/queryShape/"+sessionStorage.getItem('sessionId')
			let data = {
				id: 0,
				currentPage: this.tableDataArr.currentPage,
				pageSize: this.tableDataArr.pageSize
			}
			this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.getStyleTagFn,'vue':this})
		},
		getStyleTagFn(data) {
			if(data.msg=="ok"){
				this.tableDataArr = data.data
				this.tableData = this.tableDataArr.items
			}else{
				this.tableData = []
				this.tableDataArr.totalSize = 0
			}
		},
		//弹出框关闭
		handleClose: function(done) {
			done();
		},
		//添加零件形状
		handleAdd: function() {
			this.dialogTitle = "添加零件形状";
			this.dialogData={
				name: ""
			};
			this.dialogVisible = true;
			setTimeout(function(){
				$('.input').focus()
			},100)	
		},
		//编辑零件形状
		handleEdit: function(index, row) {
			this.dialogTitle = "编辑零件形状";
			this.dialogData = {
				id: row.id,
				name: row.name
			};
			this.dialogVisible = true;
			setTimeout(function(){
				$('.input').focus()
			},100)	
		},
		//确定添加/编辑
		handleConfirm: function() {
			if(this.dialogData.name){
				let url = ""
				let data = {
					name: this.dialogData.name
				}
				if(this.dialogTitle == "添加零件形状"){
					url = "/lightApi/product/shape/createShape/"+sessionStorage.getItem('sessionId')
				}else{
					url = "/lightApi/product/shape/modifyShape/"+sessionStorage.getItem('sessionId')
					data.id = this.dialogData.id
				}
				this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.handleConfirmFn,'vue':this})
			}else{
				this.$message({
					type: 'error',
					message: '请输入零件形状名称'
				});
			}
		},
		handleConfirmFn(data) {
			if(data.msg=="ok"){
				this.getStyleTag()
				this.dialogVisible = false
			}else{
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
		//列表复选框被选中
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除零件形状
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection					
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该形状, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "/lightApi/product/shape/deleteShape/"+sessionStorage.getItem('sessionId')+"/"+id 
					this.$store.dispatch('handleGet',{'url': url,'Fn': this.handleDeleteFn,'vue':this})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}
		},
		handleDeleteFn(data) {
			if(data.msg=="ok"){	
				this.getStyleTag()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}else{
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
        //点击页数
		handleCurrentChange(cur) {
			this.tableDataArr.currentPage = cur
			this.getStyleTag()
		},
		//改变显示条目
		handleSizeChange(size) {
			this.tableDataArr.pageSize = size
			this.getStyleTag()
		}
	},
	mounted() {
		this.getStyleTag()
	},
	components: {
		navZcy
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/shapeTag.vue